import { Link } from 'react-router-dom';

export const getPartnerLink = ({
  societyId,
  partnerId,
  partnerName,
}: {
  societyId: string;
  partnerId: string;
  partnerName: string;
}) => (
  <Link
    className="text-primary"
    to={`/detalle-socio/${societyId}/${partnerId}`}
  >
    {partnerName}
  </Link>
);
